import React from 'react';
import { View, Modal, TouchableOpacity, ScrollView } from 'react-native';
import { SubMenuItem } from '@/components/ui/therapist/CollapsibleSidebar/SubMenuItem';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';
import { SubMenuItem as SubMenuItemInterface } from '@/components/ui/therapist/CollapsibleSidebar';
import { useOverlayGuard } from '@/hooks/useOverlayGuard';

import { styles } from './styles';

export const SubMenu = ({
  subMenu,
  setExpandedSubMenu,
}: {
  subMenu: SubMenuItemInterface[] | null;
  setExpandedSubMenu: (submenu: SubMenuItemInterface[] | null) => void;
}) => {
  const { sidebarWidthValue } = useSidebarAnimation();
  useOverlayGuard(!!subMenu);

  return (
    <Modal
      visible={!!subMenu}
      transparent
      animationType="fade"
      onRequestClose={() => setExpandedSubMenu(null)}
    >
      <TouchableOpacity
        activeOpacity={1}
        onPressOut={() => setExpandedSubMenu(null)}
        style={{ flex: 1 }}
      >
        <View style={[styles.subMenuWrapper, { left: sidebarWidthValue }]}>
          <ScrollView>
            {subMenu?.map((subItem, idx) => (
              <SubMenuItem
                key={idx}
                setExpandedSubMenu={setExpandedSubMenu}
                subItem={subItem}
              />
            ))}
          </ScrollView>
        </View>
      </TouchableOpacity>
    </Modal>
  );
};
